/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type UseServiceAreaLayerAdAreasQueryVariables = Types.Exact<{
  serviceAreaUuid: Types.Scalars['ID']['input']
}>

export type UseServiceAreaLayerAdAreasQuery = {
  __typename?: 'Query'
  areas: Array<{ __typename?: 'Area'; geometry: string }>
}

export type UseServiceAreaLayerServiceAreaQueryVariables = Types.Exact<{
  serviceAreaId: Types.Scalars['ID']['input']
}>

export type UseServiceAreaLayerServiceAreaQuery = {
  __typename?: 'Query'
  serviceAreaById: {
    __typename?: 'ServiceArea'
    locationAttributes: {
      __typename?: 'LocationAttributes'
      area: {
        __typename?: 'Shape'
        points: Array<{
          __typename?: 'Location'
          latitude: number
          longitude: number
        }>
      }
    }
  } | null
}

export const UseServiceAreaLayerAdAreasDocument = gql`
    query UseServiceAreaLayerAdAreas($serviceAreaUuid: ID!) {
  areas(areaTypes: [AD], serviceAreaID: $serviceAreaUuid) {
    geometry
  }
}
    `

/**
 * __useUseServiceAreaLayerAdAreasQuery__
 *
 * To run a query within a React component, call `useUseServiceAreaLayerAdAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseServiceAreaLayerAdAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseServiceAreaLayerAdAreasQuery({
 *   variables: {
 *      serviceAreaUuid: // value for 'serviceAreaUuid'
 *   },
 * });
 */
export function useUseServiceAreaLayerAdAreasQuery(
  baseOptions: Apollo.QueryHookOptions<
    UseServiceAreaLayerAdAreasQuery,
    UseServiceAreaLayerAdAreasQueryVariables
  > &
    (
      | { variables: UseServiceAreaLayerAdAreasQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UseServiceAreaLayerAdAreasQuery,
    UseServiceAreaLayerAdAreasQueryVariables
  >(UseServiceAreaLayerAdAreasDocument, options)
}
export function useUseServiceAreaLayerAdAreasLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UseServiceAreaLayerAdAreasQuery,
    UseServiceAreaLayerAdAreasQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UseServiceAreaLayerAdAreasQuery,
    UseServiceAreaLayerAdAreasQueryVariables
  >(UseServiceAreaLayerAdAreasDocument, options)
}
export function useUseServiceAreaLayerAdAreasSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UseServiceAreaLayerAdAreasQuery,
        UseServiceAreaLayerAdAreasQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UseServiceAreaLayerAdAreasQuery,
    UseServiceAreaLayerAdAreasQueryVariables
  >(UseServiceAreaLayerAdAreasDocument, options)
}
export type UseServiceAreaLayerAdAreasQueryHookResult = ReturnType<
  typeof useUseServiceAreaLayerAdAreasQuery
>
export type UseServiceAreaLayerAdAreasLazyQueryHookResult = ReturnType<
  typeof useUseServiceAreaLayerAdAreasLazyQuery
>
export type UseServiceAreaLayerAdAreasSuspenseQueryHookResult = ReturnType<
  typeof useUseServiceAreaLayerAdAreasSuspenseQuery
>
export type UseServiceAreaLayerAdAreasQueryResult = Apollo.QueryResult<
  UseServiceAreaLayerAdAreasQuery,
  UseServiceAreaLayerAdAreasQueryVariables
>
export const UseServiceAreaLayerServiceAreaDocument = gql`
    query UseServiceAreaLayerServiceArea($serviceAreaId: ID!) {
  serviceAreaById(id: $serviceAreaId) {
    locationAttributes {
      area {
        points {
          latitude
          longitude
        }
      }
    }
  }
}
    `

/**
 * __useUseServiceAreaLayerServiceAreaQuery__
 *
 * To run a query within a React component, call `useUseServiceAreaLayerServiceAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseServiceAreaLayerServiceAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseServiceAreaLayerServiceAreaQuery({
 *   variables: {
 *      serviceAreaId: // value for 'serviceAreaId'
 *   },
 * });
 */
export function useUseServiceAreaLayerServiceAreaQuery(
  baseOptions: Apollo.QueryHookOptions<
    UseServiceAreaLayerServiceAreaQuery,
    UseServiceAreaLayerServiceAreaQueryVariables
  > &
    (
      | {
          variables: UseServiceAreaLayerServiceAreaQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UseServiceAreaLayerServiceAreaQuery,
    UseServiceAreaLayerServiceAreaQueryVariables
  >(UseServiceAreaLayerServiceAreaDocument, options)
}
export function useUseServiceAreaLayerServiceAreaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UseServiceAreaLayerServiceAreaQuery,
    UseServiceAreaLayerServiceAreaQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UseServiceAreaLayerServiceAreaQuery,
    UseServiceAreaLayerServiceAreaQueryVariables
  >(UseServiceAreaLayerServiceAreaDocument, options)
}
export function useUseServiceAreaLayerServiceAreaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UseServiceAreaLayerServiceAreaQuery,
        UseServiceAreaLayerServiceAreaQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UseServiceAreaLayerServiceAreaQuery,
    UseServiceAreaLayerServiceAreaQueryVariables
  >(UseServiceAreaLayerServiceAreaDocument, options)
}
export type UseServiceAreaLayerServiceAreaQueryHookResult = ReturnType<
  typeof useUseServiceAreaLayerServiceAreaQuery
>
export type UseServiceAreaLayerServiceAreaLazyQueryHookResult = ReturnType<
  typeof useUseServiceAreaLayerServiceAreaLazyQuery
>
export type UseServiceAreaLayerServiceAreaSuspenseQueryHookResult = ReturnType<
  typeof useUseServiceAreaLayerServiceAreaSuspenseQuery
>
export type UseServiceAreaLayerServiceAreaQueryResult = Apollo.QueryResult<
  UseServiceAreaLayerServiceAreaQuery,
  UseServiceAreaLayerServiceAreaQueryVariables
>
